import { ComponentType } from "react";
import V1_0_0 from "./entries/V1_0_0";
import V1_1_0 from "./entries/V1_1_0";

export interface Release {
  version: string;
  date: string;
  Component: ComponentType;
}

// La release la plus récente est en tête (CURRENT_VERSION = releases[0].version).
export const releases: Release[] = [
  { version: "1.1.0", date: "2026-05-11", Component: V1_1_0 },
  { version: "1.0.0", date: "2026-03-15", Component: V1_0_0 },
];

export const CURRENT_VERSION = releases[0].version;
